import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer';
import useContactSales from '@/hooks/organization/contactSales';
import { FormControl, Input, Text, VStack } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

interface Props {
  contractId: string;
  isOpen: boolean;
  onClose: () => void;
}

type ContactForm = {
  subject: string;
  message: string;
};

const ContactSalesModal = ({ contractId, isOpen, onClose }: Props) => {
  const methods = useForm<ContactForm>({
    mode: 'onChange',
    resolver: yupResolver(
      yup.object().shape({
        subject: yup.string().required('Subject is required').min(5, 'Subject must be at least 5 chars long'),
        message: yup.string().required('Message is required'),
      }),
    ),
  });

  const { handleSubmit, getValues, register, formState } = methods;
  const { errors, isValid } = formState;

  const { mutate, isPending } = useContactSales(onClose);

  const onSubmit = () => {
    const { subject, message } = getValues();
    mutate({ contractId, subject, message });
  };

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose} width={'50%'} height={'50vh'} backgroundColor="white">
      <VStack gap={'40px'} paddingY={'20px'}>
        <Text variant={'loraSectionTitle'}>Contact Sales</Text>

        <Text variant={'urbanistMedium'} color={'text.mediumGray'} marginBottom={'10px'}>
          Our sales team will get back to you as soon as possible.
        </Text>

        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <VStack gap={'20px'}>
              <FormControl isInvalid={!!errors.subject}>
                <Input {...register('subject')} className="custom-input" placeholder={'Subject'} />
                <Text color={'extra.red'}>{errors.subject?.message ?? ''}</Text>
              </FormControl>

              <FormControl isInvalid={!isValid && !!errors.message}>
                <Input
                  {...register('message')}
                  as={'textarea'}
                  className="custom-input"
                  style={{ minHeight: '150px', maxHeight: '350px' }}
                  placeholder={'Your Message'}
                />
                {!isValid && <Text color={'extra.red'}>{errors.message?.message ?? ''}</Text>}
              </FormControl>

              <CustomButton
                backgroundColor="primary.500"
                label="Send Message"
                width={'300px'}
                labelColor="white"
                disabled={!isValid}
                isLoading={isPending}
                buttonType={'submit'}
                style={{ marginTop: '40px' }}
              />
            </VStack>
          </form>
        </FormProvider>
      </VStack>
    </ModalContainer>
  );
};

export default ContactSalesModal;
